import { EMAIL_REGEXP, PHONE_REGEXP, SSN_REGEXP } from "lib/regexp";
import { useStore } from "stores/store";
import {
  addMethod,
  BooleanSchema,
  DateSchema,
  ObjectSchema,
  StringSchema,
  ValidationError,
} from "yup";

addMethod(ObjectSchema, "validateLocaleString", function () {
  return this.test((value = {}, { createError, path }) => {
    // get organization locales
    const locales = useStore.getState().organization?.locales || [];

    // test against empty value
    if (!value) {
      return createError({ path, message: "validate_required" });
    }

    // check all errors
    const errors = locales
      .map((key) => {
        const customPath = `${path}.${key}`;
        const val = value[key];

        // if the value exists then ok, note empty string is not considered ok
        if (val) {
          return null;
        }

        return new ValidationError(
          "validate_localestring_translation_missing", // could have the language embedded?
          val,
          customPath,
        );
      })
      .filter((error) => error !== null);

    // pass the test if no errors
    if (errors.length === 0) {
      return true;
    }

    // create a new error clustering the smaller ones
    return new ValidationError(errors);
  });
});

addMethod(StringSchema, "validateRequired", function (msg?: string) {
  return this.test((value = "", { createError, path }) => {
    if (value !== "") {
      return true;
    }

    return createError({ path, message: msg || "validate_required" });
  });
});

addMethod(BooleanSchema, "validateRequired", function (msg?: string) {
  return this.test((value, { createError, path }) => {
    if (value) {
      return true;
    }

    return createError({ path, message: msg || "validate_required" });
  });
});

addMethod(DateSchema, "validateRequired", function (msg?: string) {
  return this.test((value, { createError, path }) => {
    if (value) {
      return true;
    }

    return createError({ path, message: msg || "validate_required" });
  });
});

addMethod(StringSchema, "validateEmail", function () {
  return this.test((value = "", { createError, path }) => {
    // true if matches
    if (value === "" || EMAIL_REGEXP.test(value || "")) {
      return true;
    }

    return createError({
      path,
      message: "validate_email",
    });
  });
});

addMethod(StringSchema, "validatePhone", function () {
  return this.test((value = "", { createError, path }) => {
    // true if matches or empty value
    if (value === "" || PHONE_REGEXP.test(value || "")) {
      return true;
    }

    return createError({
      path,
      message: "validate_phone",
    });
  });
});

addMethod(StringSchema, "validateSsn", function () {
  return this.test((value = "", { createError, path }) => {
    // true if matches
    if (value === "" || SSN_REGEXP.test(value || "")) {
      return true;
    }

    return createError({
      path,
      message: "validate_ssn",
    });
  });
});

addMethod(StringSchema, "validatePassword", function () {
  return this.test((value = "", { createError, path }) => {
    const valueToTest = value || "";

    // length test
    if (valueToTest.length < 8 && valueToTest.length > 0) {
      return createError({
        path,
        message: "validate_password_min8",
      });
    }

    // all good I guess
    return true;
  });
});

addMethod(
  StringSchema,
  "validateOneOf",
  function (values: string[], msg?: string) {
    return this.test((value = "", { createError, path }) => {
      if (values.includes(value || "") === false) {
        return createError({ path, message: msg || "validate_required" });
      }

      // all good
      return true;
    });
  },
);

addMethod(
  StringSchema,
  "validateNotOneOf",
  function (values: string[], msg?: string) {
    return this.test((value = "", { createError, path }) => {
      if (values.includes(value || "") === true) {
        return createError({ path, message: msg || "validate_required" });
      }

      // all good
      return true;
    });
  },
);
